<template>
  <div class="card">
    <!-- <button @click="test">hola</button> -->
    <div class="card-header">
      <div class="d-flex flex-row contianer-fluid">
        <div class="col-2 row">
          <span class="category pt-1 text-nowrap d-flex flex-row"
            >Coincidencias totales:
          </span>
          <badge class="my-auto ml-2" slot="title-label" type="success">{{
            totalMemberships
          }}</badge>
        </div>
        <div class="col-8 d-flex">
          <h6 for="" class="mx-auto text-secondary my-auto">
            SELECCIONA MEMBRESÍAS PARA MODIFICAR
          </h6>
        </div>
        <div class="col-2 d-flex">
          <i
            v-if="isSync"
            class="fa fa-refresh text-success pointer mr-0 ml-auto"
            aria-hidden="true"
            @click="refreshTable()"
          ></i>
          <button
            v-else
            class="btn btn-sm text-nowrap my-auto rounded-pill btn-danger mr-0 ml-auto"
            @click="refreshTable()"
          >
            actualizar
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="mr-3 w-100">
        <table class="table table-hover mb-0">
          <thead class="text-light shadow">
            <tr class="rounded">
              <th class="text-center rounded-left bg-info">
                <el-tooltip :open-delay="100" placement="top">
                  <template #content>
                    {{ editAll ? "Deseleccionar Todo" : "Seleccionar Todo" }}
                  </template>
                  <input
                    type="checkbox"
                    class=""
                    aria-label="Checkbox for following text input"
                    @change="handleEditAll"
                    :checked="editAll"
                  />
                </el-tooltip>
              </th>
              <th class="col-auto bg-info">RUT</th>
              <th class="col-3 bg-info">Nombre</th>
              <th class="col-3 bg-info">Membresía</th>
              <th class="bg-info col-auto text-center">Estado</th>
              <th class="rounded-right bg-info col-2 text-center">
                Vencimiento
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div
        class="tbody overflow-auto w-100 mt-0"
        ref="tableBody"
        :class="tableData.length > 7 ? 'tbody--shadow' : ''"
      >
        <table class="table table-hover overflow-hidden">
          <tbody class="overflow-hidden">
            <tr v-for="(customer, i) in tableData" :key="i">
              <td class="text-center col-auto">
                <!-- <input
                  type="checkbox"
                  class="checkbox"
                  aria-label="Checkbox for following text input"
                  :checked="customer.exclude ? false : true"
                /> -->
                <input
                  type="checkbox"
                  class="checkbox"
                  aria-label="Checkbox for following text input"
                  :checked="editList.includes(customer.rutSocio) || editAll"
                  @change="toggleExclude(customer.rutSocio)"
                />
              </td>
              <td class="text-nowrap col-1">{{ customer.rutSocio }}</td>
              <td class="text-nowrap col-3">{{ customer.nombreSocio }}</td>
              <td class="text-nowrap text-uppercase pl-2">
                {{ customer.descripcionPlan }}
              </td>
              <td class="text-nowrap text-center">{{ customer.estadoPago }}</td>
              <td class="text-nowrap text-center col-2">
                {{ customer.fechaVencimiento }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center my-2">
      <small
        v-if="!isSync"
        class="text-danger my-auto position-absolute ml-4 mr-auto w-100 text-uppercase font-weight-bold"
        >Tu selección no está actualizada</small
      >
      <small
        v-if="tableData.length === 0 && isSync"
        class="text-danger my-auto position-absolute ml-4 mr-auto w-100 text-uppercase font-weight-bold"
        >Tu selección no ha entregado coincidencias</small
      >
      <button
        class="btn-info btn col-auto rounded-pill my-auto shadow-sm"
        :disabled="
          (editList.length === 0 && !editAll) ||
          !isSync ||
          tableData.length === 0
        "
        @click="activateEditor"
      >
        editar selección <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
      </button>
      <!-- <button
        class="btn-info btn col-auto rounded-pill my-auto ml-4 shadow-sm"
        :disabled="(editList.length === 0 && !editAll) || !isSync"
      >
        descargar selección
        <i class="fa fa-arrow-down fa-lg" aria-hidden="true"></i>
      </button> -->
    </div>
  </div>
</template>

<script>
import "perfect-scrollbar/css/perfect-scrollbar.css";
import PerfectScrollbar from "perfect-scrollbar";
import {
  Badge,
  Modal,
  CollapseItem,
  Collapse,
} from "src/components/UIComponents";
import { Tooltip } from "element-ui";
export default {
  name: "membershipsTable",
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [
          {
            _id: "mockId",
            rutSocio: "123456788-9",
            descripcionPlan: "MockPlan",
            estadoPago: "VIGENTE",
            nombreSocio: "SOCIO PLACEHOLDER",
            fechaVencimiento: "01-01-1900",
          },
        ];
      },
    },
    totalMemberships: {
      type: Number,
      default: 0,
    },
    isSync: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Badge,
    Modal,
    CollapseItem,
    Collapse,
    [Tooltip.name]: Tooltip,
  },
  data() {
    return {
      editList: [],
      editAll: false,
    };
  },
  watch: {
    editAll: function (newValue) {
      this.$emit("emitEditExclusion", {
        editAll: this.editAll,
        editList: this.editList,
      });
    },
    editList: function (newValue) {
      this.$emit("emitEditExclusion", {
        editAll: this.editAll,
        editList: this.editList,
      });
    },
  },
  computed: {
    // editAll() {
    //   const isExcluding = this.tableData.filter((item) => {
    //     item.exclude === true;
    //   });
    //   // console.log(isExcluding.length === 0);
    //   return isExcluding.length === 0;
    // },
  },
  methods: {
    test() {
      console.log(this.editList);
    },
    activateEditor() {
      this.$emit("activateEditor");
    },
    refreshTable() {
      this.editAll = false;
      this.editList = [];
      this.$emit("refresh");
    },
    clearEditSelection() {
      this.editAll = false;
      this.editList = [];
    },
    getEditRestriction() {
      return {
        editAll: this.editAll,
        editList: this.editList,
      };
    },
    handleEditAll() {
      this.editAll = !this.editAll;
      this.editList = [];
    },
    toggleExclude(i) {
      const nid = i;
      if (this.editList.includes(nid)) {
        this.editList = this.editList.filter((i) => i !== nid);
        this.editAll = false;
      } else if (this.editAll) {
        // console.log("por acá");
        this.editAll = false;
        this.tableData.forEach((customer) => {
          if (customer.rutSocio !== nid) {
            this.editList.push(customer.rutSocio);
          } else {
            return;
          }
        });
      } else {
        this.editList.push(nid);
      }
    },
    async initScrollBarAsync() {
      let isWindows = navigator.platform.startsWith("Win");
      if (!isWindows) {
        return;
      }
      // const PerfectScroll = await import('perfect-scrollbar')
      new PerfectScrollbar(this.$refs.tableBody);
    },
    async scrollHandler(event) {
      // console.log(event);
      const { target } = event;
      // console.log(
      //   target.scrollHeight - target.scrollTop === target.clientHeight
      // );
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        this.$emit("fetchData");
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      const scrollableDiv = this.$refs.tableBody;
      if (scrollableDiv) {
        scrollableDiv.addEventListener("scroll", this.scrollHandler);
      }
    });
  },
};
</script>

<style>
.tbody {
  max-height: 400px;
}
.tbody--shadow {
  box-shadow: inset 0px -10px 10px -10px rgba(0, 0, 0, 0.5);
}
</style>
